import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-start w-full" }
const _hoisted_2 = { class: "w-2/12 h-full item" }
const _hoisted_3 = { class: "w-10/12 md:w-5/6 flex flex-col space-y-2 ml-4" }


import TitleMedium from "@/components/Titles/TitleMedium.vue";
import TextMedium from "@/components/Texts/TextMedium.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'IconAndTextCountryInformationMenu',
  props: {
    title: {},
    text: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(TitleMedium, {
        text: props.title
      }, null, 8, ["text"]),
      _createVNode(TextMedium, {
        text: props.text ? props.text : 'None'
      }, null, 8, ["text"])
    ])
  ]))
}
}

})